module.exports = __webpack_public_path__ + "static/media/pontinhos.584de0f1.svg";